import { ChangeEvent, FC, useRef, useState } from 'react'
import { StyleFormWrapper, StyleLabel } from '../style'
import { StyleIconWrapper, StyleInput, StyleInputWrapper } from './style'
import { Field } from 'formik'
import ErrorMessage from '../ErrorMessage'
import { Icons } from '@assets'
import Svg from '../../svg'
interface InputProps {
  type?:
    | 'text'
    | 'password'
    | 'email'
    | 'url'
    | 'date'
    | 'number'
    | 'time'
    | 'datetime-local'
    | 'checkbox'
  onChange?: (value: string) => void
  onKeyDown?: (e: any) => void
  onFocus?: () => void
  onBlur?: () => void
  placeholder?: string
  label?: string
  required?: boolean
  name: string
  styleInput?: string
  styleLabel?: string
  styleWrapper?: string
  icon?: keyof typeof Icons
  side?: 'left' | 'right'
  disabled?: boolean
  autoFocus?: boolean
}
const Input: FC<InputProps> = ({
  type = 'text',
  label,
  name,
  onChange,
  styleWrapper = '',
  styleLabel = '',
  icon,
  side = 'left',
  onFocus,
  onBlur,
  ...restProps
}) => {
  const [isFocus, setIsFocus] = useState<boolean>(false)
  const inputRef = useRef<any>(null)
  const handleChange = ({ form, value }: any) => {
    if (!!onChange) {
      onChange(value)
    } else {
      form.setFieldValue(name, value)
    }
  }
  const wrapperProps =
    type == 'date' || type == 'datetime-local'
      ? {
          onClick: () => {
            inputRef.current?.showPicker?.()
          },
        }
      : {}

  return (
    <Field name={name}>
      {({ field, meta, form }) => {
        const hasError = meta.touched && meta.error
        return (
          <StyleFormWrapper styleWrapper={styleWrapper}>
            {!!label && (
              <StyleLabel hasError={hasError} styleLabel={styleLabel}>
                {label}
              </StyleLabel>
            )}
            <StyleInputWrapper {...wrapperProps}>
              {!!icon && (
                <StyleIconWrapper side={side}>
                  <Svg svg={icon} size={20} color="black" />
                </StyleIconWrapper>
              )}
              <StyleInput
                ref={inputRef}
                type={type}
                value={field?.value || ''}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  handleChange({
                    form,
                    value: event.target.value,
                  })
                }}
                hasError={hasError}
                side={side}
                hasIcon={!!icon}
                isFocus={isFocus}
                onFocus={() => {
                  setIsFocus(true)
                  !!onFocus && onFocus()
                }}
                onBlur={() => {
                  setIsFocus(false)
                  !!onBlur && onBlur()
                }}
                {...restProps}
              />
            </StyleInputWrapper>
            {!!hasError && <ErrorMessage message={meta.error} />}
          </StyleFormWrapper>
        )
      }}
    </Field>
  )
}

export default Input
